// react
import moment from "moment";
import { Map, fromJS } from "immutable";

export const initialState = fromJS({
	companyUsers: {},
});

export default function companyReducer(state = initialState, action) {
	switch (action.type) {
		case "COMPANIES:USERS.FETCHALL@SUCCESS": {
			const { companyID } = action.request.props;
			const { q } = action.request.props.params;

			const userObject = Map({
				list: action.response.get("users"),
			});

			return state.setIn(["companyUsers", companyID, q, "users"], userObject);
		}

		default:
			return state;
	}
}
